import React from 'react'
import styled from 'styled-components'
import Checkbox from '../../../../../../components/Form/Checkbox'

const Container = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  justifycontent: spaceBetween;
`

const Role = ({ onChange, options, value }) => {
  return (
    <Container style={{ height: '100%' }}>
      <div>
        {Object.keys(options).length !== 0 &&
          options.map((item, index) => (
            <>
              <Checkbox
                label={item.name}
                checked={value[0] === item.value}
                value={item.value}
                key={index + item?.name}
                onChange={onChange}
                style={{ paddingTop: 20 }}
              />
              <br />
            </>
          ))}
      </div>
    </Container>
  )
}

export default Role
